import { generatePushID } from "./generate-pushid";

export { generatePushID } from "./generate-pushid";
export { usePushID } from "./use-push-id";

export const servicePushID = [
  {
    target: "$INIT_SERVICE",
    handler: ({ setContext }) => setContext("pushid.generate", generatePushID)
  }
];
